import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "page__header",
  style: {"margin-top":"5rem","margin-bottom":"0","margin-left":"auto"}
}
const _hoisted_2 = { class: "page__row" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Управление ролями")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_UiTable = _resolveComponent("UiTable")!
  const _component_Container = _resolveComponent("Container")!

  return (_openBlock(), _createBlock(_component_Container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Btn, {
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'access-control' }))),
            style: {"white-space":"nowrap"}
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_UiTable, {
        class: "roles_table",
        cols: _ctx.cols,
        rows: _ctx.rows,
        "empty-banner-text": 'Нет данных'
      }, null, 8, ["cols", "rows"])
    ]),
    _: 1
  }))
}